module.exports = __webpack_public_path__ + "b4783297e83ca6d96e01e46ae0f8ce53.svg";